import React from 'react';

import {Helmet} from 'views/module';

import AgentReportCardScene from 'views/scenes/metrics/agent_report_card/AgentReportCard';

const AgentReportCardPage = () => {
  return (
    <>
      <Helmet>
        <title>Quilt: Agent Report Card</title>
      </Helmet>
      <AgentReportCardScene />
    </>
  );
};

export default AgentReportCardPage;
